export const SET_SPECIFICATIONS = "Setzt die Spezifikationen";
export const SET_TYPE_OF_SERVICES = "Setzt die Auftragsarten";
export const SET_REGULATIONS = "Setzt die Rechtsrahmen";
export const SET_PROCEDURE_TYPES = "Setzt die Verfahrensarten";
